import React from 'react';
import './scss/App.scss';


function App() {
  return (
    <div className="App">
    <div className="">
    <header class="header">
    <h1>
      <img
        src="https://cdn.glitch.com/7d6d7341-c200-4245-9a5e-fc29b2b2005b%2FRIDESAFELOGO_RED.png?v=1567441445779"
        alt="RideSafeLogo small"
      />
    </h1>
    </header>
    <ul  className="honeycomb">
    <li  className="honeycomb-cell">
      <img  className="honeycomb-cell__image" src="https://cdn.glitch.com/7d6d7341-c200-4245-9a5e-fc29b2b2005b%2Fmoto_enduro.png?v=1567507815520" alt=""></img>
      <div className="honeycomb-cell__title">PRE_RIDE</div>
    </li>
    <li  className="honeycomb-cell">
      <img  className="honeycomb-cell__image" src="https://cdn.glitch.com/7d6d7341-c200-4245-9a5e-fc29b2b2005b%2FRIDESAFELOGO_RED.png?v=1567441445779" alt=""></img>
      <div  className="honeycomb-cell__title">NOTES</div>
    </li>
    <li  className="honeycomb-cell">
      <img  className="honeycomb-cell__image" src="https://cdn.glitch.com/7d6d7341-c200-4245-9a5e-fc29b2b2005b%2FFortNine1.png?v=1567459510396" alt=""></img>
      <div  className="honeycomb-cell__title">RESOURCES</div>
    </li>
    </ul>
    </div>    
      <div className="grid-3-rows">
        <div className="inspection">
          <h1  className="App-link">RIDE_SAFE</h1>
          <p className="grid-p">PRE_RIDE_REPORT</p>
        </div>
        <div className="inspection">
          <h1 className="App-link">RYAN_F9</h1>
          <p className="grid-p">PRE_RIDE_CHECKS</p>
        </div>
        <div className="inspection">
          <h1 className="App-link">TCLOC_S</h1>
          <p className="grid-p">COMPREHENSIVE_CHECKS</p>
        </div>
      </div>
    </div>
  );
}

export default App;